import { LucideIcon } from 'lucide-react';

interface StatCardProps {
  icon: LucideIcon;
  label: string;
  value: string;
  change: string;
  changeType: 'positive' | 'negative';
  variant: 'blue' | 'purple' | 'orange' | 'green' | 'red';
}

export const StatCard = ({ icon: Icon, label, value, change, changeType, variant }: StatCardProps) => {
  const variantStyles = {
    blue: 'bg-white dark:bg-gray-800 border-2 border-blue-800/20 dark:border-blue-800',
    purple: 'bg-white dark:bg-gray-800 border-2 border-blue-700/20 dark:border-blue-700',
    orange: 'bg-white dark:bg-gray-800 border-2 border-slate-600/20 dark:border-slate-600',
    green: 'bg-white dark:bg-gray-800 border-2 border-blue-600/20 dark:border-blue-600',
    red: 'bg-white dark:bg-gray-800 border-2 border-slate-700/20 dark:border-slate-700'
  };

  const iconBgStyles = {
    blue: 'bg-blue-800 dark:bg-blue-700 text-white',
    purple: 'bg-blue-700 dark:bg-blue-600 text-white',
    orange: 'bg-slate-600 dark:bg-slate-600 text-white',
    green: 'bg-blue-600 dark:bg-blue-500 text-white',
    red: 'bg-slate-700 dark:bg-slate-700 text-white'
  };

  const valueStyles = {
    blue: 'text-blue-800 dark:text-blue-400',
    purple: 'text-blue-700 dark:text-blue-400',
    orange: 'text-slate-700 dark:text-slate-400',
    green: 'text-blue-600 dark:text-blue-400',
    red: 'text-slate-800 dark:text-slate-400'
  };

  return (
    <div className={`rounded-xl shadow-sm p-6 transition-all duration-200 hover:shadow-xl ${variantStyles[variant]}`}>
      <div className="flex items-start justify-between mb-4">
        <div className={`p-3 rounded-lg shadow-sm ${iconBgStyles[variant]}`}>
          <Icon className="w-6 h-6" />
        </div>
      </div>

      <div>
        <p className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">{label}</p>
        <p className={`text-3xl font-bold mb-2 ${valueStyles[variant]}`}>{value}</p>
        <p className={`text-xs font-semibold ${changeType === 'positive' ? 'text-blue-700 dark:text-blue-400' : 'text-slate-600 dark:text-slate-400'}`}>
          {change}
        </p>
      </div>
    </div>
  );
};
